(() => {
  const translations = document.querySelector('#motoradds-accessibility-labels');
  const labels = translations ? JSON.parse(translations.textContent) : {};
  // Repeated payment icons have SVG title IDs generated by Shopify.
  document.querySelectorAll('.payment-icons svg').forEach((svg,index) => {
    const title=svg.querySelector('title');
    if(title){title.id='motoradds-payment-'+index;svg.setAttribute('aria-labelledby',title.id);}
  });
  // Linked product thumbnails repeat the adjacent product title.
  const cleanRecent = () => document.querySelectorAll('[id^="RecentlyViewed-"] a img').forEach(image=>image.alt='');
  cleanRecent();
  document.querySelectorAll('[id^="RecentlyViewed-"]').forEach(region=>new MutationObserver(cleanRecent).observe(region,{childList:true,subtree:true}));
  const main = document.querySelector('#MainContent');
  if (main) main.tabIndex = -1;
  document.querySelectorAll('a[href="#MainContent"]').forEach(link => link.addEventListener('click', () => main?.focus()));
  document.addEventListener('click', event => {
    const summary = event.target.closest('.motoradds-nav-details > button');
    if (!summary) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const details = summary.parentElement;
    document.querySelectorAll('.motoradds-nav-details[open]').forEach(other => {
      if (other !== details) { other.removeAttribute('open');other.querySelector('button')?.setAttribute('aria-expanded','false'); }
    });
    if (event.detail > 0 && matchMedia('(hover: hover) and (pointer: fine)').matches) details.setAttribute('open', '');
    else details.toggleAttribute('open');
    summary.setAttribute('aria-expanded', String(details.hasAttribute('open')));
  }, true);
  document.querySelectorAll('.motoradds-nav-details').forEach(details => {
    const summary = details.querySelector('button');
    const setOpen = open => {
      details.toggleAttribute('open', open);
      summary.setAttribute('aria-expanded', String(open));
    };
    details.addEventListener('mouseenter', () => {
      if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      document.querySelectorAll('.motoradds-nav-details[open]').forEach(other => {
        if (other !== details) { other.removeAttribute('open');other.querySelector('button')?.setAttribute('aria-expanded','false'); }
      });
      setOpen(true);
    });
    details.addEventListener('mouseleave', () => {
      if (matchMedia('(hover: hover) and (pointer: fine)').matches && !details.contains(document.activeElement)) setOpen(false);
    });
    details.addEventListener('toggle', () => summary?.setAttribute('aria-expanded', String(details.hasAttribute('open'))));
    details.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault();event.stopImmediatePropagation();details.removeAttribute('open');summary.setAttribute('aria-expanded','false'); summary.focus(); }
    });
    details.addEventListener('focusout', event => {
      if (!details.contains(event.relatedTarget)) setOpen(false);
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.motoradds-nav-details[open]').forEach(details => {
      if (!details.contains(event.target)) { details.removeAttribute('open');details.querySelector('button')?.setAttribute('aria-expanded','false'); }
    });
  });
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.video-parent-section video').forEach(video => {
    video.addEventListener('play', () => { if (reducedMotion.matches) video.pause(); });
    reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) video.pause(); });
    if (reducedMotion.matches) video.pause();
  });
  document.querySelectorAll('[class*="logo-slider__track-"]').forEach(track => {
    const seen = new Set();
    [...track.children].forEach(item => {
      const image = item.querySelector('img');
      if (!image) return;
      if (seen.has(image.getAttribute('src'))) item.setAttribute('aria-hidden', 'true');
      seen.add(image.getAttribute('src'));
    });
  });
  const modal = document.querySelector('#xpandUsageModal');
  if (modal) {
    let wasOpen = false;
    let returnFocus = null;
    const isOpen = () => getComputedStyle(modal).display !== 'none';
    const observer = new MutationObserver(() => {
      const open = isOpen();
      if (open && !wasOpen) { returnFocus = document.activeElement; modal.querySelector('button')?.focus(); }
      if (!open && wasOpen) returnFocus?.focus();
      wasOpen = open;
    });
    observer.observe(modal, {attributes:true,attributeFilter:['style']});
    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault();modal.querySelector('#xpandUsageCancel')?.click(); }
      if (event.key !== 'Tab') return;
      const controls = [...modal.querySelectorAll('button,a[href],input')].filter(e => !e.disabled);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
      if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
    });
  }
  document.querySelectorAll('.errors[role="alert"],.note--success[role="status"]').forEach(message => message.focus());
  const mobileVideo = document.querySelector('#mobile-hotspot-video');
  const mobileRegion = mobileVideo?.closest('.bike-hotspot-common-video');
  if (mobileVideo && mobileRegion) {
    mobileVideo.controls = true;
    mobileVideo.tabIndex = 0;
    mobileRegion.id = 'motoradds-mobile-preview';
    mobileRegion.setAttribute('role', 'region');
    mobileRegion.setAttribute('aria-label', labels.preview_region);
    const mobile = matchMedia('(max-width: 568px)');
    const dots = [...document.querySelectorAll('.hotspot-dot')];
    let activeDot = null;
    dots.forEach(dot => {
      const title = dot.getAttribute('aria-label');
      const tooltip = document.getElementById(dot.dataset.tooltip);
      const video = tooltip?.querySelector('video');
      const hideDesktop = () => { if(tooltip)tooltip.style.display='none'; if(video){video.pause();video.currentTime=0;} };
      const showDesktop = () => {
        if(mobile.matches || !tooltip || !video)return;
        tooltip.style.display='block';video.currentTime=0;video.play().catch(()=>{});
      };
      const sync = () => {
        hideDesktop();
        if (mobile.matches) {
          dot.setAttribute('role', 'button');
          dot.setAttribute('aria-label', labels.preview.replace('__TITLE__', title));
          dot.setAttribute('aria-expanded', 'false');
          dot.setAttribute('aria-controls', mobileRegion.id);
        } else {
          dot.removeAttribute('role');dot.removeAttribute('aria-expanded');dot.removeAttribute('aria-controls');
          dot.setAttribute('aria-label', title);
        }
      };
      sync();mobile.addEventListener('change', sync);
      dot.addEventListener('focus',showDesktop);
      dot.addEventListener('mouseenter',showDesktop);
      dot.addEventListener('blur',hideDesktop);
      dot.addEventListener('mouseleave',event=>{if(!tooltip?.contains(event.relatedTarget)&&document.activeElement!==dot)hideDesktop();});
      tooltip?.addEventListener('mouseleave',event=>{if(!dot.contains(event.relatedTarget)&&document.activeElement!==dot)hideDesktop();});
      dot.addEventListener('keydown', event => {
        if(event.key==='Escape')hideDesktop();
        if (mobile.matches && event.key === ' ') {event.preventDefault();dot.click();}
      });
      dot.addEventListener('click', event => {
        if (!mobile.matches) return;
        event.preventDefault();event.stopPropagation();activeDot = dot;
        dots.forEach(other => other.setAttribute('aria-expanded', String(other === dot)));
        const shop=mobileRegion.querySelector('.mobile_shop_btn');
        shop.textContent=labels.shop_view.replace('__TITLE__',title);shop.href=dot.href;
        shop.style.opacity='1';shop.style.visibility='visible';
        mobileRegion.style.display='inline-block';
        mobileVideo.closest('.bike-hotspot-mb')?.classList.add('video-active');
        const source=video?.getAttribute('src')||video?.querySelector('source')?.src;
        if(source){mobileVideo.src=source;mobileVideo.load();mobileVideo.play().catch(()=>{});}
        mobileVideo.setAttribute('aria-label',labels.preview.replace('__TITLE__',title));mobileVideo.focus();
      });
    });
    const dismiss = () => {
      mobileVideo.pause();mobileRegion.style.display = 'none';
      mobileVideo.closest('.bike-hotspot-mb')?.classList.remove('video-active');
      dots.forEach(dot => {if(mobile.matches)dot.setAttribute('aria-expanded', 'false');});
      activeDot?.focus();
    };
    mobileRegion.addEventListener('keydown', event => {if(event.key==='Escape'){event.preventDefault();event.stopPropagation();dismiss();}});
  }
})();

